module.exports = __webpack_public_path__ + "static/media/logo-award-au40.67e0ec47.png";